import $ from 'jquery';
window.jQuery = $;
window.$ = $;
require('../../app/assets/javascripts/form-ui');
